import { render, staticRenderFns } from "./IndexPayData.vue?vue&type=template&id=00b3b13d&scoped=true&"
import script from "./IndexPayData.vue?vue&type=script&lang=js&"
export * from "./IndexPayData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b3b13d",
  null
  
)

export default component.exports